import { ModalStore } from 'ui/base/modal';
import { StringStore } from 'ui/base/input/store';

export class SearchInputStore {
  search: StringStore;
  modal: ModalStore;

  constructor() {
    this.search = new StringStore('');
    this.modal = new ModalStore(false);
  }
}
